import React, { FormEventHandler, useState } from 'react';

import { Button, DialogActions, DialogContent } from '@mui/material';

import { VARIANT_OF_REFUND_SURCHARGE } from '~/consts/refund';

import { CollectionReason } from '../../types';
import CaseIDAndReasons from '../Common/CaseIDAndReasons';
import { CogsAdjustmentVccBanner } from '../Common/CogsAdjustmentBanner';
import MarkCancelled from '../Common/MarkCancelled';
import { shouldSkipVccForCogsAdjustment } from '../Utils/RefundUtils';

import SelectRefundVariantWithSurcharge from './SelectRefundVariantWithSurcharge';

interface Props {
  currencyCode?: string;
  decrementStep: () => void;
  defaultCaseId: string;
  defaultComment: string;
  hasSurcharge?: boolean;
  onSubmit: FormEventHandler<HTMLFormElement>;
  reason: CollectionReason;
  surchargeAmount?: number;
  onSurchargeToggleChange?: (value: boolean) => void;
  approvedCogsAdjustmentAmount?: number | null;
  costCurrencyCode?: string;
}

export default function MisleadingContentIncorrectPricingAndCustomerRetention({
  currencyCode,
  decrementStep,
  defaultCaseId,
  defaultComment,
  hasSurcharge = false,
  onSubmit,
  reason,
  surchargeAmount,
  onSurchargeToggleChange,
  approvedCogsAdjustmentAmount,
  costCurrencyCode,
}: Props) {
  const [variantOfRefund, setVariantOfRefund] = useState<string>();
  const [markCancelled, setMarkCancelled] = useState<string>();
  // Same rule the payload uses
  const showVccBanner = shouldSkipVccForCogsAdjustment(
    { approved_cogs_adjustment_amount: approvedCogsAdjustmentAmount },
    markCancelled,
  );

  return (
    <>
      <DialogContent dividers>
        <form onSubmit={onSubmit} id="misleading-pricing-form">
          <CaseIDAndReasons reason={reason} defaultComment={defaultComment} defaultCaseId={defaultCaseId} />
          <SelectRefundVariantWithSurcharge
            variantOfRefund={variantOfRefund}
            setVariantOfRefund={setVariantOfRefund}
            hasSurcharge={hasSurcharge}
            currencyCode={currencyCode}
            surchargeAmount={surchargeAmount}
            onSurchargeToggleChange={onSurchargeToggleChange}
          />
          {showVccBanner && (
            <CogsAdjustmentVccBanner amount={approvedCogsAdjustmentAmount} currencyCode={costCurrencyCode} />
          )}
          {variantOfRefund !== VARIANT_OF_REFUND_SURCHARGE && (
            <MarkCancelled onChange={(_, value: string) => setMarkCancelled(value)} />
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={decrementStep}>Back</Button>
        <Button type="submit" variant="contained" form="misleading-pricing-form">
          Continue
        </Button>
      </DialogActions>
    </>
  );
}
